import styled, { css } from 'styled-components';

export const Identifier = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;

  img {
    width: 100%;
    max-width: 1200px; /* original image width: 1200px */
    height: auto;
  }

  h1 {
    font-size: 60px;
    color: #fff;
  }
`;

export const Form = styled.form`
  margin-bottom: 10px;
`;

interface IInput {
  first?: boolean;
}

export const Input = styled.input`
  width: 100%;
  height: 75px;
  border: 1px solid #e6e6f0;
  outline: 0;
  padding: 0 16px;
  font-size: 20px;
  box-sizing: border-box;

  ${({ first }: IInput) => {
    return first
      ? css`
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        `
      : css`
          border-bottom-left-radius:  8px;
          border-bottom-right-radius: 8px;
        `;
  }}
`;

export const ButtonPrimaryCustom = styled.button`
  width: 100%;
    margin-top: 50px;
    height: 58px;
    border: 0;
    outline: 0;
    font-weight: bold;
    -webkit-transition: 0.2s;
    transition: 0.2s;
    font-size: 24px;
    border-radius: 10px;
    background-color: #dcdce5;
    color: #636363;
    cursor: pointer;

    &:hover {
    background-color: #ff690a;
    color: #fff;

    .btnDisable
        {
        cursor: not-allowed;
        pointer-events: none;

        /*Button disabled - CSS color class*/
        color: #c0c0c0;
        background-color: #ffffff;

        }
}
`;
